// extracted by mini-css-extract-plugin
export default {"section":"AgentRegister_section__Jrs9x","header":"AgentRegister_header__-ryEa","active":"AgentRegister_active__VqWFB"};